import { useLayoutEffect } from 'react';
import { useSelectableContext } from './SelectableProvider.js';

var SelectableOptionsFocus = function () {
    var listRef = useSelectableContext().listRef;
    useLayoutEffect(function () {
        setTimeout(function () { var _a; return (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
    }, [listRef.current]);
    return null;
};

export { SelectableOptionsFocus };
//# sourceMappingURL=SelectableOptionsFocus.js.map
